module.exports = __webpack_public_path__ + "img/icon-pro-6.03b5d4da.png";